<script>
    export let loading = false;
    export let displayLeft = false;
</script>

{#if loading}
    <div class="control-loader" class:display-left={displayLeft}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" stroke-width="7">
            <circle fill="none" stroke-miterlimit="10" cx="50" cy="50" r="48"/>
            <line fill="none" stroke-linecap="round" stroke-miterlimit="10" x1="50"
                  y1="50" x2="85" y2="50.5">
                <animateTransform
                        attributeName="transform"
                        dur="2s"
                        type="rotate"
                        from="0 50 50"
                        to="360 50 50"
                        repeatCount="indefinite"/>
            </line>
            <line fill="none" stroke-linecap="round" stroke-miterlimit="10" x1="50"
                  y1="50" x2="49.5" y2="74">
                <animateTransform
                        attributeName="transform"
                        dur="15s"
                        type="rotate"
                        from="0 50 50"
                        to="360 50 50"
                        repeatCount="indefinite"/>
            </line>
        </svg>
    </div>
{/if}
<style>
    .control-loader {
        display: flex;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        width: 18px;
        height: 18px;
        line-height: 1;
        background: #fff;
        border-radius: 50%;
        stroke: #999;
        stroke-width: 6px;
        opacity: 0.7;
    }

    .control-loader.display-left {
        left: 10px;
        right: unset;
    }

    .control-loader svg {
        width: 100%;
    }
</style>